import type { CSSProperties } from 'react';
import { CHECK_INK_RATIO, checkMarkSize } from '@tes/domain';

// The sizing rule is the PDF engine's own (@tes/domain), re-exported here so a
// component that draws the mark can size it without a second import.
export { CHECK_INK_RATIO, checkMarkSize };

/**
 * The mark drawn in a ticked checkbox — an **X**, matching what the PDF engine
 * stamps onto the paperwork.
 *
 * Drawn as strokes rather than a text glyph so it scales cleanly to any field
 * size and never depends on which font the page happens to embed.
 */
export function CheckMark({
  size,
  color,
  style,
  title,
}: {
  size: number;
  color: string;
  style?: CSSProperties;
  /** Sets an accessible name; omit for decorative use. */
  title?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      style={style}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M3.4 3.4 L12.6 12.6 M12.6 3.4 L3.4 12.6"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
